module.exports = __webpack_public_path__ + "img/bronze_lightning.ed6e60f7.svg";